// removed by extract-text-webpack-plugin
module.exports = {"banner-image":"BannerImage-module__banner-image___2HY_a","link":"BannerImage-module__link___2D1AF","image":"BannerImage-module__image___qxcKm"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Banner/BannerImage.module.scss
// module id = 211
// module chunks = 0 1